'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _lodash = require('lodash');

var _retry = require('../utilities/retry');

var _retry2 = _interopRequireDefault(_retry);

var _poller = require('../utilities/poller');

var _poller2 = _interopRequireDefault(_poller);

var _transactions = require('../selectors/transactions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 * Polling transaction status for transactions that are in a pending/processing state.
 */
exports.default = function (_ref, _ref2) {
  var eth = _ref.eth;
  var transactionReceiptsFetched = _ref2.transactionReceiptsFetched,
      transactionReceiptsFetchFailed = _ref2.transactionReceiptsFetchFailed,
      transactionDiscardLocal = _ref2.transactionDiscardLocal;
  return function (store) {
    var dispatch = store.dispatch;

    return (0, _poller2.default)(store, {
      initialState: { lastResult: [] },

      frequency: 1000,

      checkStart: function checkStart(action) {
        return action.type === 'APP_INIT';
      },

      checkStop: function checkStop(action) {
        return action.type === 'APP_SHUTDOWN';
      },

      checkRun: function checkRun(localState, state) {
        return Object.keys(state.transactions.localTransactions).length > 0;
      },

      main: function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee(localState, state) {
          var lastResult, txHashes, newResult;
          return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  lastResult = localState.lastResult;
                  _context.prev = 1;
                  txHashes = (0, _transactions.getPendingTransactions)(state);

                  if (!txHashes) {
                    _context.next = 8;
                    break;
                  }

                  _context.next = 6;
                  return (0, _retry2.default)(function () {
                    return eth.fetchTransactionReceipts(txHashes);
                  });

                case 6:
                  newResult = _context.sent;

                  if (newResult.length && !(0, _lodash.isEqual)(newResult, lastResult)) {
                    dispatch(transactionReceiptsFetched(newResult));
                    lastResult = newResult;
                  }

                case 8:

                  (0, _transactions.getLocalTransactionsToDiscard)(store.getState()).forEach(function (txHash) {
                    store.dispatch(transactionDiscardLocal(txHash));
                  });
                  _context.next = 14;
                  break;

                case 11:
                  _context.prev = 11;
                  _context.t0 = _context['catch'](1);

                  dispatch(transactionReceiptsFetchFailed(_context.t0));

                case 14:
                  return _context.abrupt('return', { lastResult: lastResult });

                case 15:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, undefined, [[1, 11]]);
        }));

        function main(_x, _x2) {
          return _ref3.apply(this, arguments);
        }

        return main;
      }()
    });
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/middleware/pollTransactions.js
// module id = 1151
// module chunks = 0